import ctl from '@netlify/classnames-template-literals';

const buttonWithIconStyle = ctl(`
  flex
  justify-between
  items-center
  gap-2
  py-2
  px-4
`);

const buttonWithoutIconStyle = ctl(`
  py-2
  px-8
`);

export const containerStyle = (isIcon: boolean) =>
  ctl(`
    ${isIcon ? buttonWithIconStyle : buttonWithoutIconStyle}
    bg-gunmetal
    rounded-md
    max-w-xs
`);

export const textStyle = ctl(`
  text-white
  font-[600]
  whitespace-nowrap
`);

export const iconStyle = ctl(`
  text-3xl
`);
